/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UnsetAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconClose from 'DesignSystem/Svgs/TysiaIconClose/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function UnsetAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/New/ReferralSource/Content/Referrals/Referral/Source/Search/Preview/UnsetAction"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<button
  data-testid="UnsetAction.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--mr-1-27C4pT': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconClose
  viewPath={`${viewPath}/TysiaIconClose`}
 fill={dtColorsNeutral500}
 width={dtSpaceS}
 height={dtSpaceS}
/>
</button>
{children}
</React.Fragment>)
}